import {delay } from "redux-saga";
import { call, put, select } from "redux-saga/effects";
import messagingDefaultGuardados from "../../services/messaging/guardados.json"
import { getFavoritosRefError,getFavoritosRefSuccess,addFavoritesRefSucess, addFavoritesRefError, editFavoritesRefError, deleteFavoritesRefError, deleteFavoritesRefSucess,getMessagesFavoritesServicesSuccess,getMessagesFavoritesServicessError,getTooltipFavoriteError,getTooltipFavoriteSucess,createTooltipFavoriteError,createTooltipFavoriteSucess
 } from "../actions/favoritosRef";
 import { getUserInfoSelector } from "../selectors/paymentsSelectors";

 import { ClaroSDKService } from "../../services/sdk/ClaroSDKService";

export function* getFavoriteRefSaga(action) {
  try {
    const { reference, serviceId } = action;
    // const { reference, operationId } = contact;
    yield delay(400);
    const userInfo = yield select(getUserInfoSelector);
    const requestInfo = {
       query : reference,
       lidApp : serviceId,
       operationId : "1234567890" 
    }
    
    const favoriteRef = yield call(
      ClaroSDKService.getFavoriteServices,
      requestInfo,userInfo
    );
    yield put(getFavoritosRefSuccess(favoriteRef));
  } catch (error) {
    // window.backContacts = true;
    console.log("error", error)
    yield put(getFavoritosRefError(error));
  }
}

export function* addFavoritesRefSaga(action) {
  try {
    const { contact, serviceId } = action;
    const { accountService, alias, lidFavorite, paymentReminder } = contact;

    const request = {
      contactInfo:{accountService,alias},
      lidApp:serviceId,
      lidFavorite: lidFavorite,
      paymentReminder: paymentReminder
    };

    const responseFavoritCreate = yield call(ClaroSDKService.addFavoriteServices, request);
    yield put(addFavoritesRefSucess(responseFavoritCreate));
  
  } catch (error) {
    const { contact } = action;

    if(contact.lidFavorite === undefined){
      yield put(addFavoritesRefError(error));
    }else{
      yield put(editFavoritesRefError(error));
    }
  }
}


export function* DeleteFavoriteRefSaga(action) {
  try {
    const { lidFavorite } = action;

    const request = {
      lidFavorite,
      isActive: false, 
    };

    const isDeleted = yield call(ClaroSDKService.deleteFavoriteServices, request);
    yield delay(400);
    yield put(deleteFavoritesRefSucess(isDeleted));
    
  } catch (error) {
    yield put(deleteFavoritesRefError(error));
  }
}

export function* CreateFavoriteTooltipSagas(action) {
  try {
    const userInfo = yield select(getUserInfoSelector);
    const { lidApp } = action;
    const request = {
      lidApp,
      userInfo: userInfo, 
    };

    const responseTooltipCreate = yield call(ClaroSDKService.createFavoriteTooltip, request);
    yield delay(400);
    yield put(createTooltipFavoriteSucess(responseTooltipCreate));
    
  } catch (error) {
    yield put(createTooltipFavoriteError(error));
  }
}

export function* GetFavoriteTooltipSagas(action) {
  try {
    console.log('entra sagas')
    const userInfo = yield select(getUserInfoSelector);
    const { lidApp } = action;
    const request = {
      lidApp,
      userInfo: userInfo, 
    };

    const isActiveTooltip = yield call(ClaroSDKService.getFavoriteTooltip, request);
    console.log(isActiveTooltip);
    yield delay(400);
    yield put(getTooltipFavoriteSucess(isActiveTooltip));
    
  } catch (error) {
    yield put(getTooltipFavoriteError(error));
  }
}

export function* getMessagesFavoritesServicesSaga(action) {
  const { flux, code } = action;
  try {
    const messages = yield call(ClaroSDKService.messagerServiceFavoriteServices, flux, code);
    return yield put(getMessagesFavoritesServicesSuccess(messages.length ? messages : messagingDefaultGuardados));
  } catch(error) {
    return yield put(getMessagesFavoritesServicessError(messagingDefaultGuardados))
  }
}


  
  